import React, { useRef, useEffect, useState } from "react";
import UpcomingEvents from "./UpcomingEvents";
import FacebookFeed from "./FacebookFeed";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import './Sponsors.css';
import { API_BASE_URL, IMG_BASE } from "../apiConfig";

const Home = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error("Video autoplay failed:", error);
      });
    }
  }, []);


  const [sponsors, setSponsors] = useState([]);
  const [loadingSponsors, setLoadingSponsors] = useState(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      setLoadingSponsors(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/sponsors`);
        const data = await response.json();
        setSponsors(data);
      } catch (error) {
        console.error("Error fetching sponsors:", error);
      } finally {
        setLoadingSponsors(false);
      }
    };
    fetchSponsors();
  }, []);

  const sponsorLogosForMarquee = sponsors.length > 0 ? sponsors.map(s => s.LogoFile.startsWith('http') ? s.LogoFile : IMG_BASE + s.LogoFile) : [];

  const supportedLogos = [
    "/MKS-changes/MKS-Support-logos/1.png",
    "/MKS-changes/MKS-Support-logos/2.png",
    "/MKS-changes/MKS-Support-logos/3.png",
    "/MKS-changes/MKS-Support-logos/4.png",
    "/MKS-changes/MKS-Support-logos/5.png",
    "/MKS-changes/MKS-Support-logos/6.png",
    "/MKS-changes/MKS-Support-logos/7.png",
    "/MKS-changes/MKS-Support-logos/8.png",
    "/MKS-changes/MKS-Support-logos/9.png"
  ];



  
  // const upcomingEvents = [
  //   {
  //     title: "Ugadi Sambhrama 2026",
  //     date: "Saturday, 28 March 2026",
  //     location: "Springvale Town Hall",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Kannada Rajyotsava 2025",
  //     date: "Saturday, 15 Nov 2025",
  //     location: "Box Hill Town Hall",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Annual Sports Meet",
  //     date: "Sunday, 12 Oct 2025",
  //     location: "TBD",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Cultural Night",
  //     date: "Friday, 05 Sept 2025",
  //     location: "Springvale Town Hall",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Community Picnic",
  //     date: "Sunday, 15 Feb 2025",
  //     location: "Botanical Gardens",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Youth Workshop",
  //     date: "Saturday, 20 July 2025",
  //     location: "Community Center",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Women's Day Celebration",
  //     date: "Saturday, 08 March 2025",
  //     location: "MKS Hall",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   },
  //   {
  //     title: "Dasara Festival",
  //     date: "Saturday, 04 Oct 2025",
  //     location: "Springvale Town Hall",
  //     image: "https://mks.org.au/wp-content/uploads/2026/01/WhatsApp-Image-2026-01-14-at-09.32.28.jpeg"
  //   }
  // ];



  // const duplicatedLogos = [...logos, ...logos];
  // const duplicated = [...supportedLogos, ...supportedLogos];

  return (
    <>
      {/* ================= WELCOME SECTION ================= */}
      <section className="welcome-section">
        <img src="/Hero1.jpg" alt="Welcome" className="welcome-bg-image" />
        <div className="welcome-overlay"></div>
        <div className="welcome-content">
          <h1>WELCOME TO MELBOURNE KANNADA SANGHA</h1>
        </div>
      </section>

      {/* ================= HERO VIDEO ================= */}
      <section className="hero-section">
        <video
          ref={videoRef}
          className="background-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="/Hero.jpg"
          disablePictureInPicture
        >
          <source
            src="/MKS-Video.mp4"
            type="video/mp4"
          />
        </video>

        {/* Optional overlay for better text visibility */}
        <div className="video-overlay"></div>

      </section>

      <UpcomingEvents />
      <FacebookFeed />
      {/* ================= UPCOMING EVENTS ================= */}
      {/* <section className="mks-events-section">
        <div className="mks-events-container"> */}

      {/* TOP HEADER */}
      {/* <div className="mks-events-top">
            <h2>Upcoming Events</h2>


          </div> */}
      {/* FEATURED EVENT */}
      {/* <div
            className="mks-featured-event"
            style={{
              backgroundImage: `linear-gradient(to right, rgba(91, 28, 28, 0.95), rgba(91, 28, 28, 0.6)), url("/Our-Story1.png")`
            }}
          >
            <div className="mks-featured-content">
              <h3>Kannada Rajyotsava Celebration</h3>
              <p>📅 Sat, Nov 18, 2024 | 5:00 PM</p>
              <p>📍 TBD Hall, Melbourne VIC</p>

              <div className="mks-featured-buttons">
                <button className="primary">Register Now</button>
                <button className="secondary">Add to Calendar</button>
                 <button className="tertiary">View More</button>
              </div>
            </div>
          </div> */}



      {/* EVENT GRID */}
      {/* <div className="mks-event-grid">

            <div className="mks-card">
              <div className="mks-card-img kids"></div>
              <div className="mks-card-body">
                <h4>Kannada Classes for Kids</h4>
                <p>📅 Sun, May 12, 2024</p>
                <p>📍 Kannada Bhavana, Melbourne</p>
                <button className="primary">Register Now</button>
                <button className="secondary">Add to Calendar</button>
                 <button className="tertiary">View More</button>
              </div>
            </div>

            <div className="mks-card">
              <div className="mks-card-img ugadi"></div>
              <div className="mks-card-body">
                <h4>Ugadi Festival</h4>
                <p>📅 Sat, Apr 13, 2024</p>
                <p>📍 TBD Hall, Melbourne</p>
                <button className="primary">Register Now</button>
                <button className="secondary">Add to Calendar</button>
                 <button className="tertiary">View More</button>
              </div>
            </div>

            <div className="mks-card">
              <div
                className="mks-card-img gala"
                style={{ backgroundImage: 'url("/Our-Story1.png")' }}
              ></div>
              <div className="mks-card-body">
                <h4>Fundraising Gala Night</h4>
                <p>📅 Fri, Jun 7, 2024</p>
                <p>📍 Grand Ballroom, Melbourne</p>
                <button className="primary">Register Now</button>
                <button className="secondary">Add to Calendar</button>
                 <button className="tertiary">View More</button>
              </div>
            </div>

            <div className="mks-card">
              <div className="mks-card-img seniors"></div>
              <div className="mks-card-body">
                <h4>Senior’s Meetup</h4>
                <p>📅 Tue, Jun 18, 2024</p>
                <p>📍 Local Community Center</p>
              <button className="primary">Register Now</button>
                <button className="secondary">Add to Calendar</button>
                 <button className="tertiary">View More</button>
              </div>
            </div>

          </div> */}

      {/* VIEW ALL */}
      {/* <div className="mks-view-all">
            <Link to="/upcoming-events">View All Events →</Link>
          </div>   */}

      {/* </div>
      </section> */}





      <section className="logo-marquee-wrapper sponsors-swiper-section">
        <div className="supported-title-container">
          <h2 className="supported-title">SPONSORS</h2>
          <div className="supported-title-line"></div>
        </div>

        <div className="sponsors-swiper-container">
          <Swiper
            key={sponsorLogosForMarquee.length}
            modules={[Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            centeredSlides={true}
            loop={sponsorLogosForMarquee.length > 3}
            speed={3000}
            autoplay={{ 
              delay: 0, 
              disableOnInteraction: false, 
              pauseOnMouseEnter: false 
            }}
            breakpoints={{
              768: { slidesPerView: 5, spaceBetween: 30 }
            }}
            className="marquee-swiper"
          >
            {loadingSponsors ? (
              <p>Loading sponsors...</p>
            ) : (
              sponsorLogosForMarquee.map((logo, index) => (
                <SwiperSlide key={index}>
                  <div className="swiper-logo-card">
                    <img src={logo} alt={`sponsor-logo-${index}`} />
                  </div>
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
      </section>

      <section className="supported-section sponsors-swiper-section">
        <div className="supported-title-container">
          <h2 className="supported-title">SUPPORTED BY</h2>
          <div className="supported-title-line"></div>
        </div>

        <div className="sponsors-swiper-container">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            centeredSlides={true}
            loop={true}
            speed={3000}
            autoplay={{ 
              delay: 0, 
              disableOnInteraction: false, 
              pauseOnMouseEnter: false 
            }}
            breakpoints={{
              768: { slidesPerView: 5, spaceBetween: 30 }
            }}
            className="marquee-swiper"
          >
            {supportedLogos.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="swiper-logo-card">
                  <img src={logo} alt={`supported-logo-${index}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

    </>
  );
};

export default Home;

